import script from "./AppAside.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAside.vue?vue&type=script&setup=true&lang=js"

import "./AppAside.vue?vue&type=style&index=0&id=11f8f610&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f8f610"]])

export default __exports__